import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_outbound_shipmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shipment_id?: number }): 
  Promise<{ result: { Id?: number, AccountId?: number, ActualWarehouseId?: number, BillOfLading?: string, CarrierId?: number, CarrierServiceTypeId?: number, ConfirmSeal?: boolean, ContactId?: number, HealthCertificateIdentifier?: string, ItemCount?: number, LoadContainerId?: number, LookupCode?: string, SealId?: string, StatusId?: number, TrailerId?: string, Contact?: { Id?: number, AddressId?: number, FirstName?: string, LastName?: string, MiddleName?: string, Notes?: string, PrimaryEmail?: string, PrimaryTelephone?: string, ReferenceCode?: string, TypeId?: number, Address?: { Id?: number, AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string } }, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number, ShipmentId?: number, DockAppointment?: { Id?: number, LookupCode?: string, StatusId?: number } }[], Account?: { Id?: number, LookupCode?: string, TypeId?: number }, Status?: { Id?: number, Name?: string } } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shipment_id?: number    }) {
      return false;
    }
}
